import Navigation from "./lib/navigation";
import stickyContent from "./lib/stickyContent";
import Accordion from "./lib/accordion";
import tracking from "./lib/tracking";
import SmoothScroll from "smooth-scroll";
import Splide from "@splidejs/splide";
import GLightbox from "glightbox";

/* -------------------------------------------------------------------
  utility
------------------------------------------------------------------- */
const headerEl = document.querySelector(".header");
let cachedHeaderHeight = headerEl ? headerEl.offsetHeight : 0;
window.addEventListener(
  "resize",
  () => {
    cachedHeaderHeight = headerEl ? headerEl.offsetHeight : 0;
  },
  { passive: true },
);

const smoothScroll = new SmoothScroll('a[href*="#"]', {
  speed: 500,
  speedAsDuration: true,
  popstate: true,
  updateURL: false,
  offset: (anchor, toggle) => {
    if (toggle.href == "#") {
      return 0;
    } else {
      return cachedHeaderHeight;
    }
  },
});

Navigation("js-header-btn", "body");
stickyContent("footer", "header");
tracking();

const faq = new Accordion(".js-faq", {
  speed: 400,
  target: "next",
  event: "click",
  display: "flex",
});

const initBannerSlider = () => {
  const slider = document.querySelector(".js-banner-list");
  if (!slider) return;

  const splide = new Splide(slider, {
    type: "slide",
    fixedWidth: "400px",
    perMove: 1,
    pagination: false,
    arrows: true,
    focus: "center",
    trimSpace: false,
    speed: 600,
    gap: "var(--banner-list-gap)",
    padding: {
      left: "var(--banner-list-pd-inline)",
      right: "var(--banner-list-pd-inline)",
    },
    mediaQuery: "min",
    breakpoints: {
      768: {
        destroy: true,
      },
    },
  });
  splide.mount();
};

const topFvSlider = () => {
  const slider = document.querySelector(".js-top-fv");
  if (!slider) return;

  const splide = new Splide(slider, {
    type: "fade",
    rewind: true,
    autoplay: true,
    interval: 6000,
    speed: 600,
    pagination: false,
    arrows: false,
    pauseOnHover: false,
    pauseOnFocus: false,
    drag: false,
    swipe: false,
    keyboard: false,
  });

  splide.mount();
};

const classSlider = () => {
  const sliders = document.querySelectorAll(".js-class-slider");
  if (!sliders.length) return;

  sliders.forEach((slider) => {
    const splide = new Splide(slider, {
      type: "fade",
      rewind: true,
      autoplay: true,
      interval: 6000,
      speed: 600,
      pagination: true,
      arrows: true,
      pauseOnHover: false,
      pauseOnFocus: false,
    });

    splide.mount();
  });
};

const createFooterMap = async () => {
  const mapEl = document.getElementById("Map");
  if (!mapEl) return;

  const { Map } = await google.maps.importLibrary("maps");
  const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");

  const pins = [
    {
      lat: 34.722893652951456,
      lng: 135.72565379389792,
      icon: THEME_URL + "/assets/pin-hirose.svg",
    },
    {
      lat: 34.72700560019318,
      lng: 135.72044415255442,
      icon: THEME_URL + "/assets/pin-2nd.svg",
    },
  ];

  const bounds = new google.maps.LatLngBounds();
  pins.forEach((p) => bounds.extend(p));

  const map = new Map(mapEl, {
    center: bounds.getCenter(),
    zoom: 15,
    disableDefaultUI: true,
    mapId: "78bbb9c66dbddddbe0f360ad",
  });

  pins.forEach((pin) => {
    const icon = document.createElement("img");
    icon.src = pin.icon;
    icon.width = 40;
    icon.height = 40;

    new AdvancedMarkerElement({
      position: { lat: pin.lat, lng: pin.lng },
      map,
      content: icon,
    });
  });

  map.fitBounds(bounds, 60);
};

document.addEventListener("DOMContentLoaded", () => {
  topFvSlider();
  initBannerSlider();
  classSlider();
  createFooterMap();
});

const lightbox = GLightbox({
  selector: ".js-gallery",
  touchNavigation: true,
});

document.addEventListener("DOMContentLoaded", () => {
  const postcode = document.querySelector('input[name="postcode"]');
  const pref = document.querySelector('input[name="address-pref"]');
  const city = document.querySelector('input[name="address-city"]');
  const street = document.querySelector('input[name="address-street"]');
  const address1 = document.querySelector('input[name="address-1"]');

  if (!postcode || !pref || !city || !street || !address1) return;

  const fillAddress1 = () => {
    const merged = `${pref.value || ""}${city.value || ""}${
      street.value || ""
    }`.trim();
    if (merged) address1.value = merged; // ← これが必要
  };

  // 郵便番号入力後に少し待って結合（yubinbangoの反映待ち）
  postcode.addEventListener("input", () => setTimeout(fillAddress1, 80));
  postcode.addEventListener("change", () => setTimeout(fillAddress1, 80));

  // hidden側が変わった時も追従
  ["input", "change"].forEach((evt) => {
    pref.addEventListener(evt, fillAddress1);
    city.addEventListener(evt, fillAddress1);
    street.addEventListener(evt, fillAddress1);
  });
});

/* -------------------------------------------------------------------
  URLパラメータによるCF7セレクト自動選択
------------------------------------------------------------------- */
(() => {
  const params = new URLSearchParams(window.location.search);
  const inquiryType = params.get("inquiry-type");
  if (!inquiryType) return;

  const select = document.querySelector('select[name="inquiry-type"]');
  if (!select) return;

  const decoded = decodeURIComponent(inquiryType);
  const options = select.options;
  for (let i = 0; i < options.length; i++) {
    if (
      options[i].value === decoded ||
      options[i].textContent.trim() === decoded
    ) {
      select.value = options[i].value;
      select.dispatchEvent(new Event("change", { bubbles: true }));
      break;
    }
  }
})();
